import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';

const AddStudent = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const today = new Date().toISOString().split('T')[0];
    const profilePictureRef = useRef(null);
    const idCardRef = useRef(null);

    const initialFormState = {
        std_id: "",
        regis_no: "",
        studentName: "",
        gender: "",
        address: "",
        parmanentAddress: "",
        taluka: "",
        district: "",
        state: "",
        city: "",
        pincode: "",
        dob: "",
        contactNumber: '',
        primaryContact: "",
        secondaryContact: "",
        email: "",
        profilePicture: "",
        idCardUrl: "",
        bloodGroup: "",
        academicYearMasterId: '',
        instituteGradeMasterId: '',
        instituteDivisionMasterId: '',
        sectionMasterId: sectionMasterId,
        instituteMasterId: instituteMasterId
    }

    const [studentData, setStudentData] = useState(initialFormState)
    const [teacherList, setTeacherList] = useState([])
    const [inputpdf, setInputPdf] = useState({ value: '' })
    const [inputID, setInputID] = useState({ value: '' })
    const [editId, setEditId] = useState(null)
    const [StateList, setStateList] = useState([])
    const [CityList, setCityList] = useState([])
    const [DistList, setDistList] = useState([])
    const [GradeList, setGradeList] = useState([])
    const [DivisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState()

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getStateList()
        getSectionList();
        getGradeList();
        getYearList();
    }, [])

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getStateList = () => {
        const apiUrlForInstitute = `/all-states`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setStateList(response.data.result.map((board) => {
                    return {
                        value: board.id,
                        label: board.stateName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getSectionList = () => {
        const apiUrlForSection = `/get-teacher?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSection)
            .then(response => {
                setTeacherList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setStudentData((prevData) => {
            if (type === 'checkbox') {
                return {
                    ...prevData,
                    [name]: checked,
                };
            } else if (name === 'contactNumber' || name === 'primaryContact' || name === "secondaryContact") {
                // Filter out non-numeric characters and limit to 10 digits
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 10);
                return {
                    ...prevData,
                    [name]: filteredValue,
                };
            } else if (name === 'pincode') {
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 6);
                return {
                    ...prevData,
                    [name]: filteredValue
                }
            } else if (name === "bloodGroup") {
                const filteredValue = value.replace(/[^a-zA-Z+-]/g, '');
                return {
                    ...prevData,
                    [name]: filteredValue
                }
            } else {
                return {
                    ...prevData,
                    [name]: value,
                };
            }
        })
    }

    const handleChangeState = (selectedOptions) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                state: selectedOptions.label,
            }
        })

        const apiUrlForInstitute = `/state-wise-district-city?id=${selectedOptions.value}`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setCityList(response.data.cities.map((board) => {
                    return {
                        value: board.id,
                        label: board.cityName
                    }
                }))
                setDistList(response.data.districts.map((board) => {
                    return {
                        value: board.id,
                        label: board.districtName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleChangeDist = (selectedOptions) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                district: selectedOptions.label,
                taluka: selectedOptions.label,
            }
        })
    }

    const handleGradeChange = (e) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleChangeCity = (selectedOptions) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                city: selectedOptions.label,
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(studentData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(studentData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            emailRegex.test(studentData.email) ?
                setError((prevData) => {
                    return {
                        ...prevData,
                        email: '',
                    }
                })
                : setError((prevData) => {
                    return {
                        ...prevData,
                        email: 'Enter valid Email ID',
                    }
                })
        }
    }, [studentData])

    const validateFalse = () => {
        for (const [key, value] of Object.entries(studentData)) {
            if (value === '' || value.length === 0) {
                setError((prevData) => {
                    return {
                        ...prevData,
                        [key]: 'This field is required.',
                    }
                })
            } else {
                setError((prevData) => {
                    return {
                        ...prevData,
                        [key]: '',
                    }
                })
            }
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        emailRegex.test(studentData.email) ?
            setError((prevData) => {
                return {
                    ...prevData,
                    email: '',
                }
            })
            : setError((prevData) => {
                return {
                    ...prevData,
                    email: 'Enter valid Email ID',
                }
            })
    }

    const checking = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(studentData.email)
    }

    const addSection = () => {
        const apiUrl = `/add-student`;
        if (validateForm() && checking()) {
            setLoading(true);
            authorizedAxiosSection && authorizedAxiosSection.post(apiUrl, studentData)
                .then(response => {
                    getSectionList();
                    setStudentData(initialFormState);
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            validateFalse();
        }
    }

    const deleteSection = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-teacher?id=${id}`;
            authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
                .then(response => {
                    setTeacherList((prevSectionList) => [...prevSectionList].filter((section) => section.id !== id))
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateSection = () => {
        setLoading(true);
        const apiUrl = `/edit-teacher?id=${editId}`;
        authorizedAxiosSection && authorizedAxiosSection.put(apiUrl, studentData)
            .then(response => {
                getSectionList();
                setEditId(null);
                setStudentData(initialFormState)
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleUploadProfilePicture = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            setStudentData((prevData) => {
                return {
                    ...prevData,
                    idCardUrl: "",
                }
            })
            return; // Exit function if no file is selected
        }
        setInputID(e.target)

        const fileExtension = file.name.split(".").pop().toLowerCase();
        const allowedExtensions = ['jpeg', 'png', 'jpg', 'webp'];
        const body = new FormData();
        body.append("file", file);

        if (allowedExtensions.includes(fileExtension)) {
            setLoading(true);
            const apiUrl = "uploadimage";
            authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                .then((res) => {
                    setStudentData((prevData) => {
                        if (e.target.name === 'profilePicture' && file) {
                            return {
                                ...prevData,
                                profilePicture: res.data.result,
                            }
                        }
                    })
                })
                .catch((err) => {
                    const errorMsg = err?.response?.data?.error || "Something went wrong!";
                    Swal.fire({
                        text: errorMsg
                    })
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            Swal.fire({ text: "Only jpeg, png, jpg, webp files are supported" });
        }
    }

    const handleIdCard = async (e) => {
        const file = e.target.files[0];
        if (!file) {
            setStudentData((prevData) => {
                return {
                    ...prevData,
                    idCardUrl: "",
                }
            })
            return; // Exit function if no file is selected
        }
        setInputPdf(e.target)

        const fileExtension = file.name.split(".").pop().toLowerCase();
        const allowedExtensions = ['jpeg', 'png', 'jpg', 'webp'];
        const body = new FormData();
        body.append("file", file);

        if (allowedExtensions.includes(fileExtension)) {
            setLoading(true);
            const apiUrl = "uploadimage";
            authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                .then((res) => {
                    setStudentData((prevData) => {
                        if (e.target.name === 'idCardUrl' && file) {
                            return {
                                ...prevData,
                                idCardUrl: res.data.result
                            }
                        }
                    })
                })
                .catch((err) => {
                    const errorMsg = err?.response?.data?.error || "Something went wrong!";
                    Swal.fire({
                        text: errorMsg
                    })
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            Swal.fire({ text: "Only jpeg, png, jpg, webp files are supported" });
        }
    }

    const handleInputReset = () => {
        setEditId('');
        inputpdf.value = '';
        inputID.value = '';
        setStudentData(initialFormState);
        profilePictureRef.current.value = '';
        idCardRef.current.value = '';
        setError(initialErrorState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Add Student</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-person-chalkboard"></i> Add Student</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="std_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Student Id :</label>
                                                    <input type="text" className="form-control" name="std_id" value={studentData.std_id} onChange={handleInputChange} />
                                                    {error.std_id && <p style={{ color: 'red' }}>{error.std_id}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="regis_no" className="col-form-label"><span style={{ color: "red" }}>*</span>Registration No :</label>
                                                    <input type="text" className="form-control" name="regis_no" value={studentData.regis_no} onChange={handleInputChange} />
                                                    {error.regis_no && <p style={{ color: 'red' }}>{error.regis_no}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="studentName" className="col-form-label"><span style={{ color: "red" }}>*</span>Student Name :</label>
                                                    <input type="text" className="form-control" name="studentName" value={studentData.studentName} onChange={handleInputChange} />
                                                    {error.studentName && <p style={{ color: 'red' }}>{error.studentName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="email" className="col-form-label"><span style={{ color: "red" }}>*</span>Email ID :</label>
                                                    <input type="email" className="form-control" name="email" value={studentData.email} onChange={handleInputChange} />
                                                    {error.email && <p style={{ color: 'red' }}>{error.email}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Mobile No :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="contactNumber" value={studentData.contactNumber} onChange={handleInputChange} />
                                                    {error.contactNumber && <p style={{ color: 'red' }}>{error.contactNumber}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Date Of Birth :</label>
                                                    <input type="date" className="form-control" name="dob" value={studentData.dob} onChange={handleInputChange} max={today} />
                                                    {error.dob && <p style={{ color: 'red' }}>{error.dob}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleInputChange} value={studentData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.academicYearMasterId && <p style={{ color: 'red' }}>{error.academicYearMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={studentData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class :</option>
                                                        {
                                                            GradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteGradeMasterId && <p style={{ color: 'red' }}>{error.instituteGradeMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleInputChange} value={studentData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            DivisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteDivisionMasterId && <p style={{ color: 'red' }}>{error.instituteDivisionMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Address :</label>
                                                    <input type="text" className="form-control" name="address" value={studentData.address} onChange={handleInputChange} />
                                                    {error.address && <p style={{ color: 'red' }}>{error.address}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>State :</label>
                                                    <Select
                                                        value={studentData.state == "" ? null : StateList.filter(option =>
                                                            studentData.state && studentData.state == option.label && (option.value)
                                                        )[0]}
                                                        name="state"
                                                        options={StateList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeState}
                                                    />
                                                    {error.state && <p style={{ color: 'red' }}>{error.state}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>District :</label>
                                                    <Select
                                                        value={studentData.district == "" ? null : DistList.filter(option =>
                                                            studentData.district && studentData.district == option.label && (option.value)
                                                        )[0]}
                                                        name="district"
                                                        options={DistList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeDist}
                                                    />
                                                    {error.district && <p style={{ color: 'red' }}>{error.district}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>City :</label>
                                                    <Select
                                                        value={studentData.city == "" ? null : StateList.filter(option =>
                                                            studentData.city && studentData.city == option.label && (option.value)
                                                        )[0]}
                                                        name="city"
                                                        options={CityList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeCity}
                                                    />
                                                    {error.city && <p style={{ color: 'red' }}>{error.city}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Pincode :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="pincode" value={studentData.pincode} onChange={handleInputChange} />
                                                    {error.pincode && <p style={{ color: 'red' }}>{error.pincode}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Blood Group :</label>
                                                    <input type="text" className="form-control" name="bloodGroup" value={studentData.bloodGroup} onChange={handleInputChange} />
                                                    {error.bloodGroup && <p style={{ color: 'red' }}>{error.bloodGroup}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Primary Contact :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="primaryContact" value={studentData.primaryContact} onChange={handleInputChange} />
                                                    {error.primaryContact && <p style={{ color: 'red' }}>{error.primaryContact}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Secondary Contact :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="secondaryContact" value={studentData.secondaryContact} onChange={handleInputChange} />
                                                    {error.secondaryContact && <p style={{ color: 'red' }}>{error.secondaryContact}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"> <span style={{ color: "red" }}>*</span>Permanent Address :</label>
                                                    <input type="text" className="form-control" name="parmanentAddress" value={studentData.parmanentAddress} onChange={handleInputChange} />
                                                    {error.parmanentAddress && <p style={{ color: 'red' }}>{error.parmanentAddress}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Profile Picture :</label>
                                                    <input type="file" className="form-control" name="profilePicture" onChange={handleUploadProfilePicture} ref={profilePictureRef} />
                                                    {error.profilePicture && <p style={{ color: 'red' }}>{error.profilePicture}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Id Card :</label>
                                                    <input type="file" className="form-control" name="idCardUrl" onChange={handleIdCard} ref={idCardRef} />
                                                    {error.idCardUrl && <p style={{ color: 'red' }}>{error.idCardUrl}</p>}
                                                </div>
                                                {studentData.profilePicture && (
                                                    <div style={{ marginTop: '10px' }}>
                                                        Selected Profile: <img src={`${studentData.profilePicture}`} alt="" width="70" height="60" />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-md-6 view_content_radio_btn">
                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Gender :</label>
                                                <label>
                                                    <input type="radio" name="gender" value="M" checked={studentData.gender == "M"} onChange={handleInputChange} /> Male
                                                </label>
                                                <label>
                                                    <input type="radio" name="gender" value="F" checked={studentData.gender == "F"} onChange={handleInputChange} /> Female
                                                </label>
                                            </div>
                                            {error.gender && <p style={{ color: 'red' }}>{error.gender}</p>}

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={() => { addSection(); profilePictureRef.current.value = ''; idCardRef.current.value = '' }}>Save</button>
                                                        }
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>

                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSection} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AddStudent;